import React, { useEffect, useState } from 'react'
import Loader from '../../../../components/Loader/Loader'
import Sidebar from '../../../Dashboard/Sidebar/Sidebar'
import axios from "axios"
import config from '../../../../config/config';
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";

import { toastError, toastSuccess } from "../../../../common/Toast";


export const RecallPrice = () => {

    const [loading,setLoading]=useState(false)
    const [recallprice,setRecallPrice]=useState(false)

    const token = localStorage.getItem("Token");


    useEffect(()=>{
      axios.get(`${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=Promo rules`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res)=>{ 
        
       
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID == 0) {
          
          let value=res.data.ResponseData[0].AppConfigvalue == 0 ? false : true

          setRecallPrice(value)

        }
        })
      .catch((err)=>console.log(err))
    },[])

   

    const handleChange = () => {
      setRecallPrice(!recallprice)
      // console.log(!recallprice)
      
      
      let data={
        AppConfigkey: "Recall Price Settings",
        AppConfigvalue: recallprice===false ? 1 : 0
      }
  
      const jsonobj = {};
      jsonobj.StoreConfig= data;
  
      let jsonstring = JSON.stringify(jsonobj);
  
      setLoading(true);
  
      axios
        .post(
          `${config.storeConfigBaseUrl}/storeconfig/upsert`,
          {
            type:"Promo rules",
            storeconfigxml: jsonstring,
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
            toastSuccess(SUCCESS_MESSAGE);
            // window.history.back();
            // history.goBack();
            // navigate(-1);
            // event.stopPropagation();
            // window.history.back();
          } 
          setLoading(false);
          // window.location.reload();
          
        })
        .catch((error) => {
          setLoading(false);
        });
  
  
    }; 

    // console.log(recallprice)

   
  return (
    <>
    <Loader loading={loading}/>
    <Sidebar />
    <div className="page-wrapper cardhead">
    <div className="content container-fluid">
       <div className="card">
            <div className="card-header ">
              <h4 className="card-title mb-0">Recall Price Setting</h4>
            </div>
            <div className="card-body d-flex flex-row row ">
              <div className=' col-md-2 '>
              <label>Enable Recall Price</label>
              </div>

            <div class="form-check form-switch  col-md-2 ">
            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onChange={handleChange} checked={recallprice}/>
           {/* <label class="form-check-label" for="flexSwitchCheckDefault">Default switch checkbox input</label> */}
          </div>
          </div>
        </div>
    </div>
    </div>
    </>
  )
}
